<script setup lang="ts">
import { computed, type PropType } from 'vue';
import { type CustomIcon } from '../interfaces/CustomIcon';

const props = defineProps({
  icon: {
    type: Object as PropType<CustomIcon>
  },
  text: {
    type: String,
    required: true
  }
});

const computedIconColor = computed(() => props.icon && props.icon.color ? props.icon.color : `black`);

</script>

<template>
    <div class="icon-text">
        <FontAwesomeIcon :icon="[`${icon.style}`, `${icon.icon}`]"
            class="icon"
            v-if="icon"/>
        <div>{{ text }}</div>
    </div>
</template>

<style scoped lang="scss">
.icon-text {
  display: flex;
  align-items: center;
}
.icon {
  font-size: 20px;
  margin-right: 16px;
  color: v-bind(computedIconColor);
}
</style>../interfaces/CustomIcon
